"use client";
import { Providers } from "@forestsync/ui";
import { useEffect } from "react";

export default function UIProvidersClient({
  children,
}: {
  children: React.ReactNode;
}) {
  useEffect(() => {
    if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
      navigator.serviceWorker
        .register("/sw.js")
        .then((registration) => {
          // When a new SW is installed and waiting, activate it immediately
          registration.addEventListener("updatefound", () => {
            const newWorker = registration.installing;
            if (!newWorker) return;
            newWorker.addEventListener("statechange", () => {
              if (
                newWorker.state === "installed" &&
                navigator.serviceWorker.controller
              ) {
                // New version ready — the SW will call clients.claim() and
                // navigate each client, so we don't need to do anything here.
                // This is just a no-op safety net.
              }
            });
          });
        })
        .catch(() => {
          // SW registration failed silently — app still works normally
        });
    }
  }, []);

  return <Providers>{children}</Providers>;
}
